module.exports = __webpack_public_path__ + "static/media/hashtag-nft-14.93779973.jpg";